import { useSelector } from "react-redux";
import { RootState } from "app/store";
import I18n from "common/i18n";
import { useScale } from "common/utils";
import { IconHart, IconMap, IconProject, IconPublished } from "features/user/assets";

// UserBtn のプランバッジは外枠(102*scale)を超え y=127*scale 付近まで伸びる (top offset 4*scale 含む)
// UniversalBtn は 112*scale 高。両方の実視覚下端を確実に下回るヘッダー高を確保する。
export const HEADER_HEIGHT = 132;

const StatCell = ({
  icon,
  value,
  label,
}: {
  icon: React.ReactNode;
  value: number | string;
  label: string;
}) => (
  <div className="flex-row-el items-center gap-2 px-2">
    <div className="flex-col-center w-16 h-16 shrink-0">{icon}</div>
    <div className="flex-col-el items-center gap-1">
      <p className="type-text type-title text-textcolor-black leading-none whitespace-nowrap">
        {value}
      </p>
      <p className="type-text type-sm text-textcolor-black/60 leading-tight whitespace-pre-line">
        {label}
      </p>
    </div>
  </div>
);

const Divider = () => <div className="w-px h-20 bg-textcolor-black/20 shrink-0" />;

export const UserHeader = () => {
  const { scale } = useScale();
  const status = useSelector((state: RootState) => state.user.status);

  const courseFinished = status?.course?.finished ?? 0;
  const courseTotal = status?.course?.total ?? 0;
  const projectTotal = status?.project?.total ?? 0;
  const projectPublished = status?.project?.published ?? 0;
  const projectFavorited = status?.project?.favorited ?? 0;

  return (
    <div
      className="flex-row-el relative z-[1] shrink-0 w-full items-center justify-center"
      style={{
        height: HEADER_HEIGHT * scale,
      }}
    >
      <div
        className="flex-row-center items-center gap-3 origin-center overflow-hidden rounded-2xl border-[4px] border-solid border-white bg-white shadow-[0_4px_14px_rgba(63,74,97,0.10),0_1px_0_rgba(237,227,207,0.9)] p-2"
        style={{
          transform: `scale(${scale})`,
        }}
      >
        <StatCell
          icon={<IconMap viewBox="0 0 48 48" />}
          value={`${courseFinished}/${courseTotal}`}
          label={I18n.t("MSG_USER_PROFILE_STATUS_COURSE_CLEARED")}
        />
        <Divider />
        <StatCell
          icon={<IconProject viewBox="0 0 48 48" />}
          value={projectTotal}
          label={I18n.t("MSG_USER_PROFILE_STATUS_PROJECTS")}
        />
        <Divider />
        <StatCell
          icon={<IconPublished viewBox="0 0 48 48" />}
          value={projectPublished}
          label={I18n.t("MSG_USER_PROFILE_STATUS_PUBLISHED_PROJECTS")}
        />
        <Divider />
        <StatCell
          icon={<IconHart viewBox="0 0 48 48" />}
          value={projectFavorited}
          label={I18n.t("MSG_USER_PROFILE_STATUS_PROJECT_RECEIVED_FAVORITE")}
        />
      </div>
    </div>
  );
};
